export default "__VITE_ASSET__9243681a__"